import React from "react";
import { useGetTeamQuery } from "../../../features/api/apiSlice";
import TeamMember from "./TeamMember";

function TeamMembers() {
  const { isLoading, isError, data } = useGetTeamQuery();

  let content = null;

  if (isLoading) content = "Loading....";
  if (!isLoading && isError) content = "Something Went Wrong!";
  if (!isLoading && !isError && data?.length === 0)
    content = "No Team member yet...";
  if (!isLoading && !isError && data?.length > 0)
    content = data?.map((member) => (
      <TeamMember member={member} key={member?.id} />
    ));

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}

export default TeamMembers;
